import React, { Component } from "react";
import { connect } from "react-redux";
import SelectField from "material-ui/SelectField";
import TextField from "material-ui/TextField";
import IconButton from "material-ui/IconButton";
import MenuItem from "material-ui/MenuItem";
import Toggle from "material-ui/Toggle";
import EditIcon from "material-ui/svg-icons/editor/mode-edit";
import CloseIcon from "material-ui/svg-icons/navigation/close";
import SaveIcon from "material-ui/svg-icons/action/done";

import { renderMerchantHeaderInfos } from "./utils";
import {
  loadParameters,
  deleteParameter,
  saveParameter,
  editMode,
  changeParameterInputs,
  loadETicket,
  saveETicket
} from "./actions";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";

import "./common.css";
import "./Parameter.css";

class Config extends Component {
  editClick = () => {
    const { id, editMode } = this.props;
    editMode(id);
  };

  saveParameter = e => {
    const { code, value, saveParameter } = this.props;
    saveParameter(code, value);
    e.preventDefault();
  };

  changeCode = (e, i, value) => {
    const { id, changeParameterInputs } = this.props;
    changeParameterInputs(id, "code", value);
  };

  changeValue = (e, value) => {
    const { id, changeParameterInputs } = this.props;
    changeParameterInputs(id, "value", value);
  };

  deleteClick = e => {
    const { id, code, deleteParameter } = this.props;
    deleteParameter(id, code);
  };

  renderBtns() {
    const style = { width: "20px" };
    return this.props.editing ? (
      <div className="btns">
        <IconButton iconStyle={style} type="submit">
          <SaveIcon />
        </IconButton>
      </div>
    ) : (
      <div className="btns">
        <IconButton iconStyle={style} onClick={this.editClick}>
          <EditIcon />
        </IconButton>
        <IconButton iconStyle={style} onClick={this.deleteClick}>
          <CloseIcon />
        </IconButton>
      </div>
    );
  }

  render() {
    const { code, value, codes, editing } = this.props;
    return (
      <form className="parameter-row fieldset" onSubmit={this.saveParameter}>
        <SelectField
          hintText="Nom"
          className="field"
          value={code}
          disabled={!editing}
          onChange={this.changeCode}
          autoWidth
        >
          {codes.map((code, index) => (
            <MenuItem key={index} value={code} primaryText={code} />
          ))}
        </SelectField>
        <TextField
          hintText="Valeur"
          className="field"
          value={value}
          disabled={!editing}
          onChange={this.changeValue}
        />
        {this.renderBtns()}
      </form>
    );
  }
}

const renderNewConfig = (
  canAdd,
  codes,
  code,
  value,
  deleteParameter,
  saveParameter,
  changeParameterInputs
) => {
  if (canAdd) {
    return (
      <Config
        value={value}
        code={code}
        codes={codes}
        editing={true}
        deleteParameter={deleteParameter}
        saveParameter={saveParameter}
        changeParameterInputs={changeParameterInputs}
      />
    );
  }
};

const availableKeys = (configs, codes, current) => {
  const configsCodes = configs.map(x => x.code);
  return codes.filter(x => x === current || configsCodes.indexOf(x) < 0);
};

class Parameter extends Component {
  componentDidMount() {
    const { detail, loadParameters, loadETicket, user } = this.props;
    if (checkPrivileges(user.privileges, auth.DISPLAY_SPECIFIC_PARAMETERS))
      loadParameters(detail.code);
    if (checkPrivileges(user.privileges, auth.DISPLAY_E_TICKET))
      loadETicket(detail.code);
  }

  deleteParameter = (id, code) => {
    const { detail, deleteParameter } = this.props;
    deleteParameter(id, detail.code, code);
  };

  saveParameter = (code, value) => {
    const { detail, saveParameter } = this.props;
    saveParameter(detail.code, code, value);
  };

  renderParameters({ parameters }) {
    if (parameters) {
      const { configs, codes, newConfig } = parameters;
      const usedCodes = configs.map(x => x.code);
      const canAdd = codes.filter(x => usedCodes.indexOf(x) < 0).length > 0;
      return (
        <div>
          {configs.map(config => (
            <Config
              id={config.id}
              key={config.id}
              code={config.code}
              value={config.value}
              editing={config.editing}
              codes={availableKeys(configs, codes, config.code)}
              deleteParameter={this.deleteParameter}
              saveParameter={this.saveParameter}
              editMode={this.props.editMode}
              changeParameterInputs={this.props.changeParameterInputs}
            />
          ))}
          {renderNewConfig(
            canAdd,
            availableKeys(configs, codes),
            newConfig.code,
            newConfig.value,
            this.deleteParameter,
            this.saveParameter,
            this.props.changeParameterInputs
          )}
        </div>
      );
    }
  }

  saveETicket = (e, value) => {
    const merchantCode = this.props.detail.code;
    this.props.saveETicket(merchantCode, value);
  };

  renderETicket = () => {
    const { eTicket } = this.props;
    if (eTicket !== undefined) {
      const eTicketText = !!eTicket ? "Activée" : "Désactivée";
      return (
        <div>
          <Toggle
            className="e-ticket-toggle"
            onToggle={this.saveETicket}
            defaultToggled={!!eTicket}
            style={{ width: "60px", display: "inline-block" }}
          />
          <div className="e-ticket-text">{eTicketText}</div>
        </div>
      );
    }
  };

  render() {
    const { merchantLibelle, mainResortLibelle, user } = this.props;
    return (
      <div className="card-container">
        <div className="card edit-list">
          {renderMerchantHeaderInfos(
            checkPrivileges(user.privileges, auth.DISPLAY_MERCHANT_HEADER),
            merchantLibelle,
            mainResortLibelle
          )}
          {checkPrivileges(
            user.privileges,
            auth.DISPLAY_SPECIFIC_PARAMETERS
          ) ? (
            <div className="param-container">
              <div className="title">Configuration spécifique</div>
              {this.renderParameters(this.props)}
            </div>
          ) : null}
          {checkPrivileges(user.privileges, auth.DISPLAY_E_TICKET) ? (
            <div className="param-container">
              <div className="title">Production du e-ticket</div>
              {this.renderETicket()}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  detail: state.merchant.detail,
  parameters: state.merchant.parameters,
  eTicket: state.merchant.eTicket,
  merchantLibelle: state.merchant.detail.libelle,
  mainResortLibelle: state.merchant.detail.mainResortLibelle,
  user: state.app.auth.user
});

const mapDispatchToProps = dispatch => ({
  loadParameters: code => {
    dispatch(loadParameters(code));
  },
  deleteParameter: (id, merchantCode, code) => {
    dispatch(deleteParameter(id, merchantCode, code));
  },
  saveParameter: (merchantCode, code, value) => {
    dispatch(saveParameter(merchantCode, code, value));
  },
  editMode: id => {
    dispatch(editMode(id));
  },
  changeParameterInputs: (id, field, value) => {
    dispatch(changeParameterInputs(id, field, value));
  },
  loadETicket: code => {
    dispatch(loadETicket(code));
  },
  saveETicket: (merchantCode, status) => {
    dispatch(saveETicket(merchantCode, status));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Parameter);



// WEBPACK FOOTER //
// ./src/merchant/Parameter.js